<ng-container *ngFor="let pieceName of workOrderPiece;">
    <div class="cursor-pointer items-center gap-4 border-b">
        <div class="capitalize etage flex align-items-center justify-between py-3">
            <button class="hide-in-pdf w-auto flex align-items-center" style="font-family: 'Inter var'; font-weight: 500;" (click)="toggleChevron(pieceName)">
                {{ pieceName }}
                <mat-icon
                    class="icon-size-4 text-current"
                    [svgIcon]="chevronIsOpen(pieceName) ? 'heroicons_solid:chevron-down' : 'heroicons_solid:chevron-right'">
                </mat-icon>
            </button>

            <mat-icon [svgIcon]="'heroicons_outline:plus'" (click)="quickAdd(pieceName)"></mat-icon>
        </div>

        <div *ngIf="chevronIsOpen(pieceName)" class="grid border-b bg-accent-50">
            <div class="table-grid grid grid-cols-[1fr,1fr,auto] items-center gap-4 py-3 px-6 md:px-8 text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5 border-b">
                <div>Type de travaux</div>
                <div>Dimension</div>
                <div>Détails</div>
            </div>
            <ng-container *ngFor="let workOrder of workOrderGroupForPiece(pieceName)">
                <div class="table-grid grid grid-cols-[1fr,1fr,auto] items-center gap-4 py-3 px-6 md:px-8" [formGroup]="workOrder">
                    <div class="capitalize">
                        <mat-form-field class="w-full">
                            <input type="text"
                                   matInput
                                   formControlName="type"
                                   [matAutocomplete]="workOrderInput">
                            <mat-autocomplete #workOrderInput="matAutocomplete">
                                <mat-option (blur)="updateWorkOrder(workOrder)" *ngFor="let workOrderType of workOrderTypesAutofill(workOrder)" [value]="workOrderType.name">{{workOrderType.name}}</mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="capitalize">
                        <mat-form-field class="w-full">
                            <input type="text" matInput (blur)="updateWorkOrder(workOrder);" formControlName="dimension">
                        </mat-form-field>
                    </div>
                    <div>
                        <button mat-icon-button [matTooltip]="'Supprimer'" (click)="delete(workOrder)">
                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
